module.exports = __webpack_public_path__ + "static/media/v3.fff6cc4e.mp4";